/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RouteBuilderCustomRoadBlockagesQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
  filter?: Types.InputMaybe<Types.CustomRoadBlockageFilterInput>
}>

export type RouteBuilderCustomRoadBlockagesQuery = {
  __typename?: 'Query'
  customRoadBlockages: Array<{
    __typename?: 'RoadBlockage'
    id: string
    name: string
    status: Types.RoadBlockageStatus
    reason: Types.RoadBlockageReason
    validFrom: string | null
    validTo: string | null
    segments: Array<{
      __typename?: 'RoadSegment'
      name: string
      geometry: string
      direction: Types.RoadSegmentDirection
    }>
  }>
}

export const RouteBuilderCustomRoadBlockagesDocument = gql`
    query RouteBuilderCustomRoadBlockages($regionId: ID!, $filter: CustomRoadBlockageFilterInput) {
  customRoadBlockages(regionId: $regionId, filter: $filter) {
    id
    name
    status
    reason
    validFrom
    validTo
    segments {
      name
      geometry
      direction
    }
  }
}
    `

/**
 * __useRouteBuilderCustomRoadBlockagesQuery__
 *
 * To run a query within a React component, call `useRouteBuilderCustomRoadBlockagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteBuilderCustomRoadBlockagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteBuilderCustomRoadBlockagesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRouteBuilderCustomRoadBlockagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  > &
    (
      | {
          variables: RouteBuilderCustomRoadBlockagesQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  >(RouteBuilderCustomRoadBlockagesDocument, options)
}
export function useRouteBuilderCustomRoadBlockagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  >(RouteBuilderCustomRoadBlockagesDocument, options)
}
// @ts-ignore
export function useRouteBuilderCustomRoadBlockagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderCustomRoadBlockagesQuery,
  RouteBuilderCustomRoadBlockagesQueryVariables
>
export function useRouteBuilderCustomRoadBlockagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderCustomRoadBlockagesQuery,
        RouteBuilderCustomRoadBlockagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RouteBuilderCustomRoadBlockagesQuery | undefined,
  RouteBuilderCustomRoadBlockagesQueryVariables
>
export function useRouteBuilderCustomRoadBlockagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RouteBuilderCustomRoadBlockagesQuery,
        RouteBuilderCustomRoadBlockagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RouteBuilderCustomRoadBlockagesQuery,
    RouteBuilderCustomRoadBlockagesQueryVariables
  >(RouteBuilderCustomRoadBlockagesDocument, options)
}
export type RouteBuilderCustomRoadBlockagesQueryHookResult = ReturnType<
  typeof useRouteBuilderCustomRoadBlockagesQuery
>
export type RouteBuilderCustomRoadBlockagesLazyQueryHookResult = ReturnType<
  typeof useRouteBuilderCustomRoadBlockagesLazyQuery
>
export type RouteBuilderCustomRoadBlockagesSuspenseQueryHookResult = ReturnType<
  typeof useRouteBuilderCustomRoadBlockagesSuspenseQuery
>
export type RouteBuilderCustomRoadBlockagesQueryResult = Apollo.QueryResult<
  RouteBuilderCustomRoadBlockagesQuery,
  RouteBuilderCustomRoadBlockagesQueryVariables
>
